import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  listFeedbackCollectionLinksApiService,
  type FeedbackCollectionLinkItem,
  type InternalTokenStatus,
  type ListFeedbackCollectionLinksResult,
} from "@/generated/fastapi";

export type {
  FeedbackCollectionLinkItem,
  InternalTokenStatus as FeedbackLinkStatus,
  ListFeedbackCollectionLinksResult,
};

export async function listFeedbackLinks(
  accessToken: string | null | undefined,
): Promise<ListFeedbackCollectionLinksResult> {
  const response = await listFeedbackCollectionLinksApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to load feedback links (${response.status})`);
  }

  if (response.data.status !== "success") {
    throw new Error(response.data.message || "Failed to load feedback links");
  }

  return response.data;
}
